import {
  AuditReportsBlueprintMetadataDto,
  AuditReportsBooleanColumnConfigDto,
  AuditReportsDateColumnConfigDto,
  AuditReportsDateTimeColumnConfigDto,
  AuditReportsReportDefinitionDataDto,
  AuditReportsReportDefinitionEntity,
  AuditReportsStringColumnConfigDto,
  AuditReportsStringColumnConfigDtoCaseEnumKey,
  AuditReportsTimeColumnConfigDto,
} from '@mi-front/api-v2';

/** User customization data stored by a report definition. */
export type ReportDefinitionData = AuditReportsReportDefinitionDataDto;

/** Form model that exposes persisted definition data under the `data` field. */
export type ReportDefinition = Omit<AuditReportsReportDefinitionEntity, 'definition'> & {
  data: ReportDefinitionData;
};
/** Report blueprint metadata returned by the audit reports API. */
export type BlueprintMetadata = AuditReportsBlueprintMetadataDto;
export type BlueprintSection = BlueprintMetadata['sections'][number];
export type BlueprintColumn = BlueprintSection['columns'][number];
/** Persisted report definition returned by the audit reports API. */
export type ReportDefinitionEntity = AuditReportsReportDefinitionEntity;
/** Boolean column configuration. */
export type BooleanColumnConfigDto = AuditReportsBooleanColumnConfigDto;
/** Date column configuration. */
export type DateColumnConfigDto = AuditReportsDateColumnConfigDto;
/** Date and time column configuration. */
export type DateTimeColumnConfigDto = AuditReportsDateTimeColumnConfigDto;
/** String column configuration. */
export type StringColumnConfigDto = AuditReportsStringColumnConfigDto;
/** Supported string casing option. */
export type StringColumnConfigDtoCaseEnumKey = AuditReportsStringColumnConfigDtoCaseEnumKey;
/** Time column configuration. */
export type TimeColumnConfigDto = AuditReportsTimeColumnConfigDto;

export type DefinitionDataSection = NonNullable<
  NonNullable<ReportDefinitionData['sections']>[number]
>;

/** Single column in a definition section (with config and label). */
export type DefinitionDataColumn = NonNullable<
  NonNullable<DefinitionDataSection['columns']>[number]
>;

/** Column config shape used by definition columns (type-specific options). */
export type DefinitionColumnConfig = DefinitionDataColumn['config'];

export type Language = 'en' | 'es';
export type Languages = Language[];

/** Localized label used by report definition sections and columns. */
export type LocalizedLabel = ReportDefinitionData['sections'][number]['label'];

/** Default category ID used for uncategorized columns. */
export const DEFAULT_CATEGORY_ID = 'base';
